// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__263oF","content":"styles_content__3Xfyn"};